import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import BillingPlanCardHeader from '@/components/Billing/BillingPlanCardHeader.vue';
// @ts-ignore
import BillingPlanCardSlotHandler from '@/components/Billing/BillingPlanCardSlotHandler.vue';
import BillingService from '@/components/Billing/billing-service';
import { Plan, SelectOption } from '@/components/Billing/billing-types';
import { addBigNumberSuffix } from '@/utils/helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'BillingPlanCard',
  props: {
    plan: null,
    isActive: { type: Boolean },
    isSelected: { type: Boolean },
    displayName: null,
    descriptionsTitle: null,
    isCurrentTeamTasksVirtuallyUnlimited: { type: Boolean },
    currentAccountCustomerFeatureQuantity: null,
    planDescriptions: null
  },
  emits: ["select-plan", "update-virtual-unlimited-selection", "update-customer-features-tasks-quantity"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'select-plan'): void;
	(e: 'update-virtual-unlimited-selection', isVirtuallyUnlimited: boolean): void;
	(e: 'update-customer-features-tasks-quantity', customerFeaturesTasksQuantity: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	plan: Plan;
	isActive: boolean;
	isSelected: boolean;
	displayName: string;
	descriptionsTitle: string;
	isCurrentTeamTasksVirtuallyUnlimited?: boolean;
	currentAccountCustomerFeatureQuantity?: number;
	planDescriptions: { text: string; isSupported: boolean }[];
}



const { billingPeriod, isAnnuallyPlan } = useBilling();
const selectedTab = ref(props.isSelected && props.isCurrentTeamTasksVirtuallyUnlimited ? 1 : 0);
const isCustomerFeaturesPlan = computed(() => BillingService.isCustomerFeaturesPlan(props.plan));
const isPaidPlan = computed(() => BillingService.isPaidPlan(props.plan));
const tasksPriceMap = computed(() =>
	isCustomerFeaturesPlan.value && isPaidPlan.value ? BillingService.getTasksPriceMap(props.plan, billingPeriod.value) : {}
);
const selectOptions = computed<SelectOption[]>(() =>
	Object.keys(tasksPriceMap.value).map<SelectOption>((key) => ({
		value: parseInt(key),
		text: `${addBigNumberSuffix(key)} monthly tasks`,
		suffixText: `$${tasksPriceMap.value[parseInt(key)]} per ${isAnnuallyPlan.value ? 'year' : 'month'}`,
	}))
);
const selectedCustomerFeatureTasksAmount = ref(
	props.isSelected ? props.currentAccountCustomerFeatureQuantity : selectOptions.value[0]?.value || 0
);
const updateSelectedTab = (tabIndex: number) => {
	selectedTab.value = tabIndex;
	emit('update-virtual-unlimited-selection', tabIndex === 1);
	if (props.isSelected) {
		emit('select-plan');
	}
};

return { __sfc: true,emit, props, billingPeriod, isAnnuallyPlan, selectedTab, isCustomerFeaturesPlan, isPaidPlan, tasksPriceMap, selectOptions, selectedCustomerFeatureTasksAmount, updateSelectedTab, BillingPlanCardHeader, BillingPlanCardSlotHandler }
}

})